import { inject, Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import _ from 'lodash';
import { map, Observable, of, switchMap } from 'rxjs';
import { ContractorSettings } from '../../../../_shared/model';
import { StorageService } from '../../../../_shared/services';
import { SetContractorSettings } from '../../../../_shared/state/base/base.actions';
import { BaseState } from '../../../../_shared/state/base/base.state';
import { ConfigGuiService } from './config-gui.service';

@Injectable({
    providedIn: 'root',
})
export class ContractorSettingsApplicationService {
    private storage = inject(StorageService);
    private store = inject(Store);
    private configGuiService = inject(ConfigGuiService);

    public getContractorSettings(cid: number, fromCache = false): Observable<ContractorSettings> {
        if (fromCache) {
            const contractorSettings: ContractorSettings = this.store.selectSnapshot(BaseState.GetContractorSettings);
            return of(_.cloneDeep(contractorSettings));
        }

        return this.configGuiService.getContractorGuiSettings(cid).pipe(
            switchMap(settings => {
                if (settings) {
                    const contractorSettingsValue = new ContractorSettings().deserialize(settings);
                    this.storage.setContractorSettings(contractorSettingsValue);
                    return this.store.dispatch(new SetContractorSettings(contractorSettingsValue)).pipe(map(() => contractorSettingsValue));
                }
                return of(null);
            }),
        );
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public setAndSaveContractorSettings(cid: number, data: ContractorSettings): Observable<ContractorSettings> {
        return this.configGuiService.setContractorGuiSetting(cid, data).pipe(
            map(response => {
                // Only save to storage and store if backend call was successful
                this.storage.setContractorSettings(data);
                this.store.dispatch(new SetContractorSettings(data));
                return response;
            }),
        );
    }
}
